import { z } from "zod";
export const hrActionManagementSchema = z.object({
  action_type: z.string().min(1, { message: "Required" }),
  action_source: z.string().min(1, { message: "Required" }),
  amount: z.preprocess(
    (val) => Number(val),
    z.number().min(0, { message: "Must be at least 0" })
  ),
  remark: z.string().min(1, { message: "Required" }),
  user_id: z.preprocess(
    (val) => Number(val),
    z.number().min(1, { message: "Required" })
  ),
  date: z.preprocess((val) => new Date(val as string), z.date()),
});

// export const hrActionManagementSchema = z.object({
//   // kpi_id: z.number().optional(),
//   action_type: z.string().min(1, { message: "Required" }),
//   action_source: z.string().min(1, { message: "Required" }),
//   amount: z.number().min(1, { message: "Must be at least 10000" }),
//   remark: z.string().min(1, { message: "Required" }),
//   user_id: z.number().min(1, { message: "Required" }),
//   date: z.date(),
// });
